import { render, staticRenderFns } from "./AsyncCombobox.vue?vue&type=template&id=15b3c8e2"
import script from "./AsyncCombobox.vue?vue&type=script&lang=js"
export * from "./AsyncCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports